// Section 18: the policy catalog (23 policies). PolicyId is keyof Policies (core/types).
import type { Config } from '../../config';
import { checkRegistryKeys, type PolicyRegistry } from '../../core/registry';
import { announceRations } from './announce-rations';
import { askOnShortage } from './ask-on-shortage';
import { burial } from './burial';
import { childLabour } from './child-labour';
import { festival } from './festival';
import { foodFloor } from './food-floor';
import { foodPriority } from './food-priority';
import { foodRation } from './food-ration';
import { guardMandate } from './guard-mandate';
import { healthCare } from './health-care';
import { householdSharing } from './household-sharing';
import { housing } from './housing';
import { justice } from './justice';
import { migration } from './migration';
import { pairing } from './pairing';
import { retirementAge } from './retirement-age';
import { schoolSubjects } from './school-subjects';
import { schooling } from './schooling';
import { seedReserve } from './seed-reserve';
import { toolAllocation } from './tool-allocation';
import { warmth } from './warmth';
import { waterRation } from './water-ration';
import { workIntensity } from './work-intensity';

/** Build the policies registry for a config (content numbers come from the config, ADR-0008). */
export function buildPolicies(config: Config) {
  const policies = Object.freeze({
    foodRation: foodRation(config),
    foodFloor: foodFloor(config),
    foodPriority: foodPriority(config),
    seedReserve: seedReserve(config),
    waterRation: waterRation(config),
    warmth: warmth(config),
    healthCare: healthCare(config),
    toolAllocation: toolAllocation(config),
    housing: housing(config),
    announceRations: announceRations(config),
    householdSharing: householdSharing(config),
    childLabour: childLabour(config),
    schooling: schooling(config),
    schoolSubjects: schoolSubjects(config),
    retirementAge: retirementAge(config),
    workIntensity: workIntensity(config),
    pairing: pairing(config),
    migration: migration(config),
    justice: justice(config),
    guardMandate: guardMandate(config),
    festival: festival(config),
    burial: burial(config),
    askOnShortage: askOnShortage(config),
  } satisfies PolicyRegistry);
  checkRegistryKeys('policies', policies);
  return policies;
}
